import React, { useEffect, useState, useRef } from 'react';
import { Styles } from "./styles/serviceBox.js";
import img1 from "../../src/politicalimgeas/Homecards/2.png";
import img2 from "../../src/politicalimgeas/Homecards/1.avif";
import scrollingimg from "../../src/politicalimgeas/cardscrolling/bg1.jpeg";
import scrollingimg1 from "../../src/politicalimgeas/cardscrolling/bg2.jpeg";
import scrollingimg2 from "../../src/politicalimgeas/cardscrolling/bg3.jpeg";
import scrollingimg3 from "../../src/politicalimgeas/cardscrolling/bg4.jpeg";
import scrollingimg4 from "../../src/politicalimgeas/cardscrolling/bg5.jpeg";
import scrollingimg5 from "../../src/politicalimgeas/cardscrolling/bg6.jpg";
import scrollingimg6 from "../../src/politicalimgeas/cardscrolling/bg7.jpg";
import { GetApi } from '../services/CommonService2.js';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min.js';
import LoginModal from './LoginModal.js';


function ConstituencyDevelopments() {
    const containerRef = useRef(null);
    const scrollAmount = 220;

    const scrollCards = (direction) => {
        if (containerRef.current) {
            containerRef.current.scrollBy({ left: direction * scrollAmount, behavior: "smooth" });
        }
    };
    useEffect(() => {
        getData()
    }, [])

    const [data, setData] = useState([])
    const [modalUp, setModalUp] = useState(false)
    const [showError, setShowError] = useState(false)
    const history = useHistory()

    const getData = async () => {
        const reqparams = {
            pageno: "-1",
            query: { status: 'Active' },
        }

        const Response = await GetApi(reqparams, "CONSTITUENCYDEVELOPMENTS")
        // console.log("Dev Response", Response);
        setData(Response.data)
    }

    const nextpage=async(data)=>{
        // var tntId = JSON.parse(localStorage.getItem('tID'))

        // const userdata = JSON.parse(localStorage.getItem(`userdata${tntId}`))
        // if (userdata == null) {
        //     setModalUp(true)
        //     toast.info('login to check course details', {
        //         position: "top-right",
        //         autoClose: 5000,
        //         hideProgressBar: false,
        //         closeOnClick: true,
        //         pauseOnHover: true,
        //         draggable: true,
        //         progress: undefined,
        //         theme: "light",
        //     });
        // }
        // else {
            history.push({
                pathname: "/constituencydevelopments",
                state: data
                
            })
        // }

    }
    const openModal = () => {
        setModalUp(false)
    }

    const logIn = () => {

    }

    return (
        <>
            <Styles>
                <section className="why-Visualpath">
                    <div class="card-scrolling container-fluid">
                        <div class="educational-heading">
                            <h1>Constituency Developments</h1>
                            {/* <p>"Comprehensive educational programs designed for skill enhancement, career
                            growth, and academic excellence."</p> */}
                        </div>
                        <br/>
                        {/* <h2 class="text-secondary p-2 text-decoration-underline fw-bold text-start my-2">2024-2025</h2> */}
                        <div className="card-wrapper" ref={containerRef}>
                            {data?.map((ele, index) => (
                                <div className="card" key={index}>
                                    <a onClick={()=>nextpage(ele)}>
                                        <img src={ele.image} alt={`Image ${index}`} />
                                    </a>
                                </div>
                            ))}
                        </div>

                        <button class="arrow left" onClick={() => scrollCards(-1)}>&#10094;</button>
                        <button class="arrow right" onClick={() => scrollCards(1)}>&#10095;</button>
                    </div>
                </section>
                {modalUp && <LoginModal onClose={openModal} login={logIn}></LoginModal>}
            </Styles>
        </>
    )
}

export default ConstituencyDevelopments